import React from "react";
import { Clock, MessageCircle, ShieldCheck, ShoppingBag, Sparkles, Workflow } from "lucide-react";

import Bloco from "../../ofertas-do-dia/admin/regras/Bloco";

// Explica o que a CLEO faz. Tempos e travas são padrão do sistema (a loja não configura).
export default function ComoFunciona({ regras }) {
  const r = regras || {};
  const passos = [
    { icone: MessageCircle, titulo: "O cliente conversa e pede o cardápio",
      texto: "O link sai marcado com a conversa: a CLEO sabe se ele abriu e o que colocou no carrinho." },
    { icone: Clock, titulo: "A CLEO espera o cliente parar",
      texto: `Decide ${r.espera_min || 9} min depois da última resposta. Se ele ainda está mexendo no cardápio, espera ele parar (no máximo ${r.espera_max_min || 30} min).` },
    { icone: ShieldCheck, titulo: "Confere antes de chamar",
      chips: [`Não pediu nas últimas ${r.ja_pediu_h || 6}h`, "Loja aberta", "Sem atendimento humano", "No máximo 1 por dia"] },
    { icone: Sparkles, titulo: "Escreve uma mensagem só pra ele",
      texto: "Lê a conversa, o carrinho, o último pedido e as promoções e cupons ativos. Se o cliente recusou ou não era compra, não manda." },
    { icone: ShoppingBag, titulo: "Conta a venda",
      texto: `Pedido em até ${r.janela_conversao_h || 2}h depois da mensagem entra como venda recuperada no relatório.` },
  ];
  return (
    <Bloco icone={Workflow} titulo="Como a CLEO trabalha" corIcone="bg-amber-500/15 text-amber-500"
      subtitulo="Tudo automático: você só escolhe o jeito de falar." e2e="como-funciona">
      <ol className="relative space-y-4">
        {passos.map(({ icone: Icone, titulo, texto, chips }, i) => (
          <li key={titulo} className="flex gap-3">
            <div className="flex flex-col items-center">
              <span className="w-8 h-8 rounded-full bg-amber-500/15 text-amber-600 dark:text-amber-400 flex items-center justify-center shrink-0">
                <Icone className="w-4 h-4" />
              </span>
              {i < passos.length - 1 && <span className="w-px flex-1 bg-border mt-1" aria-hidden="true" />}
            </div>
            <div className="pb-1 min-w-0">
              <p className="text-sm font-semibold leading-tight">{titulo}</p>
              {texto && <p className="text-xs text-muted-foreground mt-0.5 leading-snug">{texto}</p>}
              {chips && (
                <div className="flex flex-wrap gap-1.5 mt-1.5">
                  {chips.map((c) => (
                    <span key={c} className="inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-medium">
                      <ShieldCheck className="w-3 h-3 text-emerald-500" /> {c}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </li>
        ))}
      </ol>
    </Bloco>
  );
}
